/**
 * Implement an Iframe handler that is wrapped by a browser frame
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './BrowserFrame.module.scss'

const BrowserFrame = ({
  src,
  enableMobile,
  hidden
}) => (
  <div className={cx(styles['browser-frame'], {
    'd-none': !!hidden,
    [styles['mobile']]: enableMobile
  })}>
    {enableMobile ? null : (
      <img
        className={cx(styles['browser-header'])}
        src='/static/assets/img/backdrops/browser-addressbar.svg'
        alt='browser header' />
    )}
    <iframe
      className={cx(styles['browser-iframe'], {
        [styles['mobile']]: enableMobile
      })}
      src={src}
      frameBorder={0} />
  </div>
)

BrowserFrame.propTypes = {
  src: PropTypes.string.isRequired,
  enableMobile: PropTypes.bool,
  hidden: PropTypes.bool
}

export default BrowserFrame
